
export default {
  name: 'ProductDetailRowsContent',

  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeItems: new Array(this.data?.length).fill(false),
    };
  },

  methods: {
    toggleItemActive(index) {
      this.$set(this.activeItems, index, !this.activeItems[index]);
    },
  },
};
